export default __webpack_public_path__ + "static/media/blog-15.7abf6a66.jpeg";